import { render, staticRenderFns } from "./SelectOrganisationForm.vue?vue&type=template&id=277ed53d&"
import script from "./SelectOrganisationForm.vue?vue&type=script&lang=js&"
export * from "./SelectOrganisationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports